module.exports = __webpack_public_path__ + "img/gift4-01-c05-y2.238144e9.png";